import { Routes, Route, Navigate } from 'react-router-dom'
import SignInForm from '../components/modules/authentication/SignInForm'
import { SignUpPage } from '../components/modules/authentication/SignUp/part1/SignUpPage'
import { CompleteSignUp } from '../components/modules/authentication/SignUp/part2/CompleteSignUp'
// material
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { esES } from '@mui/material/locale'
import { AuthContextProvider } from '../context/AuthContext'
import { QueryClientProvider } from '@tanstack/react-query'
import GlobalContextProvider from '../context/GlobalState'
import { BulkInvoiceProvider } from '../context/BulkInvoiceContext'
import { BulkScheduledProvider } from '../context/BulkScheduledContext'
import Loader from '../components/modules/Loader'
import { Toaster } from 'sileo'
import ModalDialog from '../components/modules/ModalDialog'
import BukSyncNotifier from '../components/BukSyncNotifier'
import FirstLastNavigationTracker from '../components/FirstLastNavigationTracker'
import AuthGuard from './AuthGuard'
import PlanRestrictedRoute from './PlanRestrictedRoute'
import { queryClient } from './queryClient'

//components
import BusinessInsights from '../pages/BusinessInsights'
import Administracion from '../pages/Administracion'
import Reportes from '../pages/Reportes/Reportes'
import ReportesMarketing from '../pages/ReportesMarketing'
import MiContador from '../pages/MiContador'
import Ajustes from '../pages/Ajustes'
import ContableAgent from '../pages/ContableAgent'
import Tickets from '../pages/Tickets'
import { AuthLayout } from '../components/modules/authentication/components/SignUpLayout'
import { ResetPassword } from '../components/modules/authentication/resetPassword/part1/ResetPassword'
import { ActionAuth } from '../components/modules/authentication/ActionAuth'
import { CompleteResetPassword } from '../components/modules/authentication/resetPassword/part2/CompleteResetPassword'
import { FormCompleteInvitation } from '../components/modules/authentication/SignUp/completeInvitation/FormCompleteInvitation'
import { StepForm5 } from '../components/modules/authentication/SignUp/part2/Step5Form'
import Facturacion from '../pages/Facturacion'
import MercadoPagoCallback from '../pages/MercadoPagoCallback'
import Inventario from '../pages/Inventario'
import ImpersonationEntry from '../pages/ImpersonationEntry'

// styles
const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#00CCCC'
      },
      secondary: {
        main: '#FF3A0B'
      }
    }
  },
  esES
)

const AppRoutes = () => {
  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <GlobalContextProvider>
          <BulkInvoiceProvider>
            <BulkScheduledProvider>
              <AuthContextProvider>
                <Loader />
                <ModalDialog />
                <Toaster position='bottom-right' options={{ fill: '#000033' }} />
                <BukSyncNotifier />
                <FirstLastNavigationTracker />

                <Routes>
                  <Route path='/impersonation-entry' element={<ImpersonationEntry />} />

                  <Route path='/auth' element={<AuthLayout />}>
                    <Route path='signin' element={<SignInForm />} />
                    <Route path='signup' element={<SignUpPage />} />
                    <Route path='reset-password' element={<ResetPassword />} />
                    <Route path='action' element={<ActionAuth />} />
                    <Route path='complete-signup' element={<CompleteSignUp />} />
                    <Route path='complete-reset-password' element={<CompleteResetPassword />} />
                    <Route path='complete-invitation' element={<FormCompleteInvitation />} />
                    <Route path='*' element={<Navigate to='/auth/signin' replace />} />
                  </Route>

                  <Route path='/' element={<AuthGuard />}>
                    <Route index element={<BusinessInsights />} />
                    <Route path='complete-signup/poll-sii' element={<StepForm5 />} />
                    <Route path='ajustes' element={<Ajustes />} />
                    <Route path='BusinessInsights' element={<BusinessInsights />} />
                    <Route path='administracion' element={<Administracion />} />
                    <Route path='inventario' element={<Inventario />} />
                    <Route path='mercadopago/callback' element={<MercadoPagoCallback />} />
                    <Route path='reportes' element={<Reportes />} />
                    <Route path='reportes-marketing' element={<ReportesMarketing />} />
                    <Route
                      path='micontador'
                      element={
                        <PlanRestrictedRoute requiredPermission='allowAccountingDesk'>
                          <MiContador />
                        </PlanRestrictedRoute>
                      }
                    />
                    <Route path='tickets' element={<Tickets />} />
                    <Route
                      path='facturacion'
                      element={
                        <PlanRestrictedRoute requiredPermission='allowIntelligentBilling'>
                          <Facturacion />
                        </PlanRestrictedRoute>
                      }
                    />
                    <Route path='chat' element={<ContableAgent />} />
                    <Route path='*' element={<Navigate to='/' replace />} />
                  </Route>
                </Routes>
              </AuthContextProvider>
            </BulkScheduledProvider>
          </BulkInvoiceProvider>
        </GlobalContextProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

export default AppRoutes
